import { css } from 'styled-components';

import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';

const pxOrAuto = (value?: number) => value ? `${value}px` : 'auto';

export type TSizesProps = {
    /**
     * Ширина
     *
     * @default auto
     */
    $width?: number,

    /**
     * Минимальная ширина
     *
     * @default 300
     */
    $minWidth?: number,

    /**
     * Максимальная ширина
     *
     * @default 100% - safe indent
     */
    $maxWidth?: number,

    /**
     * Высота
     *
     * @default auto
     */
    $height?: number,

    /**
     * Минимальная высота
     *
     * @default 100
     */
    $minHeight?: number,

    /**
     * Максимальная высота
     *
     * @default 100% - safe indent
     */
    $maxHeight?: number,
}

const getSizes = () => ({ theme, $width, $minWidth = 300, $maxWidth, $height, $minHeight = 100, $maxHeight }: ThemedProperties<TSizesProps>) => {
    const maxSize = {
        tablet: `calc(100% - ${theme.indents.xxxxxxl}px)`,
        mobile: `calc(100% - ${theme.indents.xxxxxl}px)`,
    };

    /*
    * If max-width/max-height has value, takes it in pixels, otherwise takes a given value
    * */
    const maxWidthOr = (value: string) => {
        return $maxWidth ? `${$maxWidth}px` : value;
    };
    const maxHeightOr = (value: string) => {
        return $maxHeight ? `${$maxHeight}px` : value;
    };

    return css`
        width: ${pxOrAuto($width)};
        min-width: max(${$minWidth}px, 200px);
        max-width: min(
            ${maxWidthOr(maxSize.mobile)},
            ${maxSize.mobile}
        );
        
        height: ${pxOrAuto($height)};
        min-height: max(${$minHeight}px, 100px);
        max-height: min(
            ${maxHeightOr(maxSize.mobile)},
            ${maxSize.mobile}
        );

        @media (min-width: ${theme.breakpoints.tablet}) {
            max-width: min(
                ${maxWidthOr(maxSize.tablet)},
                ${maxSize.tablet}
            );

            max-height: min(
                ${maxHeightOr(maxSize.tablet)},
                ${maxSize.tablet}
            );
        }
    `;
};

export default getSizes;
